import { render } from "./GeneratedReportsHistory.vue?vue&type=template&id=2cd6a97e&scoped=true"
import script from "./GeneratedReportsHistory.vue?vue&type=script&lang=js"
export * from "./GeneratedReportsHistory.vue?vue&type=script&lang=js"

import "./GeneratedReportsHistory.vue?vue&type=style&index=0&id=2cd6a97e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd6a97e"]])

export default __exports__